import React from "react";

export default function FullPageLoader(props: { show: boolean; className?: string }): ReturnType<React.FC> {
    let { show, className } = props
    const showHideClassName = `${show ? 'loader-full' : 'display-none'}${className ? ` ${className}` : ''}`;

    return (
        <div className={showHideClassName}>
            <div className=" loader loader-default is-active loader-main" data-text="loading"></div>
        </div>
    );
};
